import { useMemo } from 'react'

export const useIsMobile = () => {
    return useMemo(() => {
        if (typeof window === 'undefined') return false
        return /Mobi|Android|iPhone|iPad|iPod|Touch/i.test(navigator.userAgent)
    }, [])
}
